import React from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { storage, db } from '../../firebase';
import { collection } from 'firebase/firestore';
import './HotelRoomDisplay.css';
import { Link, useNavigate } from 'react-router-dom';
import LoaderPage from '../../Comonents/Loader/Load';

export const HotelRoomDisplay = () => {
  const navigate = useNavigate();
  const [rooms, loading, error] = useCollection(collection(db, 'Rooms'));

  const handleBooking = (roomId, roomTitle) => {
    navigate(`/booking/${roomId}`, { state: { roomTitle } }); // Pass roomTitle via state
  };

  const truncateText = (text, maxLength) => {
    const words = text.split(' ');
    if (words.length > maxLength) {
      return words.slice(0, maxLength).join(' ') + '...';
    }
    return text;
  };

  return (
    <div className="hotelRoomDisplay">
      <div className="roomDisplayHeader">
        <h1>Explore Our Exclusive Rooms</h1>
      </div>

      {loading && <LoaderPage/>}
      {error && <p>Error fetching rooms</p>}

      {rooms && (
        <div className="roomCardsContainer">
          {rooms.docs.map((room) => {
            const data = room.data();
            return (
              <div key={room.id} className="roomCard">
                <img src={data.iconImageUrl} alt={data.title} className="roomIcon" />
                <div className="roomCardContent">
                  <div className='room-element'>
                <p className="roomPrice"><s>Price: Rs.{data.price}</s></p>
                <p className="roomDiscountedPrice">Discounted <br/>Price: Rs.{data.discountedPrice}</p>
                </div>
                  <h3 className="roomTitle">{data.title}</h3>
                  <p className="roomShortDesc">{truncateText(data.p1, 10)}</p>
                  
                  
                  <div className="roomButtons">
                    <button className="viewDetailsButton">
                      <Link to={`/room/${room.id}`} className="viewDetailsLink">View Details</Link>
                    </button>
                    <button
                      className="bookNowButton"
                      onClick={() => handleBooking(room.id, data.title)}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
